import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import './styles.scss'
export const Video = ({
  filename,
  poster
}: {
  filename: string
  poster: string
}) => {
  const [isPlaying, setIsPlaying] = useState(false)
  return (
    <div className='Video'>
      {!isPlaying && (
        <div className='posterwrapper' onClick={() => setIsPlaying(!isPlaying)}>
          <img src={require('images/' + poster)} />
          <div className='playicon' />
        </div>
      )}
      {isPlaying && (
        <ReactPlayer
          className='react-player'
          width='100%'
          url={require('images/' + filename)}
          playing={true}
          playsinline
          muted
          loop
          controls={true}
        />
      )}
    </div>
  )
}
